import { BlockBase, HeadlineHeader } from "components/page/user/contractFrk/edit/parts/blockBase";
import { DISPLAY_TYPES } from "constants/defaultInputValueTypes";
import React from "react";
import Validation from "util/validate";
import { SEND_OTHER_PAPER } from "../../../../../../../constants/messages";
import InputTextRemark from "../../input/inputTextRemark";

/** 備考 */
export default class Block1 extends BlockBase {
    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            headlineId: "021801",
        };
        // 入力値のチェック用オブジェクトを生成
        this.validation = new Validation();
    }

    render() {
        const { hideBlockClass, params } = this.renderCommon();

        // 文字数制限定義
        const JYU01748LimitMsg =
            this.validation.limitTextAreaFrk(
                this.props.contractTypeId,
                this.state.headlineId.substring(0, 4),
                "JYU01748",
                this.props.pageState.JYU01748);

        // 非表示判定の場合、null(react的な表示なし)を返す
        if (this.dohide(this.props.pageState.hidingHeadline)) { return null; }

        // JYU01748の別紙送りボタン表示制御
        let itemJYU01748 = undefined;
        if (this.props.displayTypeID === DISPLAY_TYPES.LAND.value) {
            // 土地の場合、別紙送りボタン非表示
            itemJYU01748 = <InputTextRemark disableReturn id="ID_JYU01748" name="JYU01748" value={this.props.pageState.JYU01748} text={SEND_OTHER_PAPER.JYU01748} placeholder={JYU01748LimitMsg.inputLimitGuide} {...params} />;
        } else {
            itemJYU01748 = <InputTextRemark id="ID_JYU01748" name="JYU01748" value={this.props.pageState.JYU01748} text={SEND_OTHER_PAPER.JYU01748} placeholder={JYU01748LimitMsg.inputLimitGuide} {...params} />;
        }

        return (
            <div className={`dataList dataList__accordion ${hideBlockClass}`}>
                <div className="dataList-header">
                    <div className="dataList-header-title">備考</div>
                    <HeadlineHeader onClick={this.handleHide} hide={this.state.hide} />
                </div>
                <div className="dataList-body">
                    <table className="dataTable">
                        <tbody>
                            <tr>
                                <th className="dataTable-title dataTable-title__w120 dataTable-title__center">備考</th>
                                <td className="dataTable-body" colSpan="3">
                                    <div className="dataTableTextUnit">
                                        {itemJYU01748}
                                        <p className="LengthOver-error">{JYU01748LimitMsg.inputLimitMsg}</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}